import { constants } from 'src/app/shared/common/contants';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from './../../shared/models/validationmethod';
import { LocalStorageSettingsService } from './../../shared/services/local-storage-settings.service';
import { Tool } from '../jmigrator-tools/Tool';
import { Path } from '../jmigrator-tools/Path';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators, FormControl, FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { JMigratorService } from './JMigrator.Service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { csvToSQLData } from './CsvToSqlData';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonService } from 'src/app/shared/services/common.service';
import { FiledownloadComponent } from 'src/app/shared/common/filedownload.component';
import { environment } from 'src/environments/environment';
import { CommonTs } from 'src/app/shared/common/CommonTs';
import { RestApi } from 'src/app/shared/RestApi/restApi';
import { UserRoutingModule } from 'src/app/user/user-routing/user-routing.module';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import { RetrieveScreenAccess } from 'src/app/shared/models/userrole';
import { MatDialog } from '@angular/material/dialog';
import { UsernameConfigurationComponent } from './username-configuration.component';


@Component({
    selector: 'app-jmigrator-tools',
    templateUrl: './jmigrator-tools.component.html',
    styleUrls: ['./jmigrator-tools.component.scss'],
    standalone: false
})
export class JMigratorToolsComponent implements OnInit {



xmlType=null;
selectedFile: File | null = null;
selectedOracleFile: File | null = null;
selectedTemplateFile: File | null = null;



  columnDefsForObjects;
  defaultColDef;
  columnDefs;
  grid;
  gridApi;
  logGrid;
  R3API;
  R3Data: any = [];
  tool: Tool[];
  getdata:any;
  toolsData: any = [];
  logData: any = [];
  toolsLogData: any = [];
  toolDescriptionBinding: any;
  isSplited: boolean = false;
  toolDescriptionModel: Path = { toolCatalogueId: '', sourceFolder: '', destFolder: '' };
  csvToSqlToolDescriptionModel: csvToSQLData = { toolCatalogueId: '', csvFileFolder: '', databasename: '' };
  statevaluechange={"fileName":"","fileData":"","path":"","action":"","databasename":"","actioName":"","userAction":"","objectName":"","noOfRecord":0, "isSplited":this.isSplited}


  caseStateData = { fileData:[],fileName:''}

  columnDefsForLog;
  columnDefsForxmlsplitter;
  dataExtractor;
  columnDefsForR3Extractor;
  columnDefsForcsvtosql;
  columnDefsForR3XMLtoMySQL;
  columnDefsForState;
  backgroundColorScreen = "";
  buttonColor = "";
  validation_messages;
  csvToSql: boolean = false;
  validations_form: UntypedFormGroup;
  validations_path_form:UntypedFormGroup;
  validations_csvToSql_form:UntypedFormGroup;
  validations_caseState_form: UntypedFormGroup;

  rowSelection;
  components;
  rowClassRules;
  retrieveToolLog;
  $ev;
  caseState: boolean = false;
  producttypeupdate:boolean=false;
  xmlcase: boolean = false;
  xmlsplitter:boolean= false;
  //migrationtooltemplate:boolean=false;
  radiobutton:boolean=false;
  R3xmlExtraction:boolean=false;
  R3xmltoMySQL:boolean = false;
  csvsplitter:boolean=false;
  fileToUpload : File | null = null;
  filesLength:number=null;
  FormValid: UntypedFormGroup;
  FormValidProductType:UntypedFormGroup;
  FormValidCsv:UntypedFormGroup;
  FormValidR3Extractor:UntypedFormGroup;
  FormValidCaseAudit:UntypedFormGroup;
  dataExtractorPaginationPageSize:number = 10;
  //choose image
  imagephoto;
  imagephotoshow: any = false;
  dataExtractorTool:boolean = false;
  oracleToExcelToFtp:boolean = false;
  FormValidOracle: UntypedFormGroup;
oracleColumns:any;
oracleGrid:any;
oracleData:any[] = [];
  stateChange:any=[]
  lastpage;
  currentpage;
  nextpage;
  nextpageplusone;
  totalpages;
  paginationNumberFormatter;
  pageSize;
  toolCatalogueId;
  actionDetails: any = []
  objectNames:any = []
  toolname;
  selectedCompanyid;
  paginationPageSize;
  temptooldata;
  statedatatemp:any=[]
  producttypedatatemp:any=[]
  selectedObjectName;
  responserequest;

  dashboardCounts = {
  totalSets: 0,
  queuedSets: 0,
  inProgressSets: 0,
  currentStatus: '',
  completedSets: 0,
  failedSets: 0,
  remainingSets: 0,

  totalCases: 0,
  casesInProgress: 0,
  casesCompleted: 0,
  casesFailed: 0,
  casesRemaining: 0
};
   showSetDashboard  = true;

  constructor(private router: Router,
    private restApi:RestApi,
    private migratorService: JMigratorService,
    private httpClient: HttpClient,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    public formBuilder: UntypedFormBuilder,
    private localStorageSettings: LocalStorageSettingsService,
    private snackBar: MatSnackBar,
    private validation: validationmethod,
    private msg: ErrorMessages,
    private fb: UntypedFormBuilder,
    private constants: constants,
    private spinner: NgxUiLoaderService,
    private commonService: CommonService,
    private commonTs:CommonTs,
    private userRoutingModule: UserRoutingModule,private linkservice: ReportlinksserviceService, private retrieveScreenAccess: RetrieveScreenAccess
  ) {
    this.validation_messages = this.msg.toolConfiguration;
    this.components = {
      buttonRenderer: FiledownloadComponent,
    }
  }
  select(value){
    //console.log(value);
    this.xmlType=value;
    //console.log(this.xmlType)
      }

      toggleDashboard(): void {
  this.showSetDashboard  = !this.showSetDashboard ;
}

  formValidation() {
    this.validations_form = new UntypedFormGroup({
      'toolCatalogueId': new UntypedFormControl('', [Validators.required]),
      'toolName': new UntypedFormControl(''),
      'endpoints': new UntypedFormControl(''),
      'input': new UntypedFormControl(''),
      'output': new UntypedFormControl(''),
      'toolDescription': new UntypedFormControl(''),
      'instructionToUse': new UntypedFormControl(''),
      'usage': new UntypedFormControl(''),


    })
    this.validations_path_form =new UntypedFormGroup({
      'toolCatalogueId': new UntypedFormControl('', [Validators.required]),
      'sourceFolder': new UntypedFormControl('', [Validators.required, this.validation.noWhitespaceValidator]),
      'destFolder': new UntypedFormControl('', [Validators.required, this.validation.noWhitespaceValidator]),
    })
    this.validations_csvToSql_form =new UntypedFormGroup({
      'toolCatalogueId': new UntypedFormControl('', [Validators.required]),
      'databasename': new UntypedFormControl('', [Validators.required, Validators.pattern('[0-9a-zA-Z$_#@]+'),this.validation.noWhitespaceValidator,],),
      'csvFileFolder': new UntypedFormControl('', [Validators.required, this.validation.noWhitespaceValidator]),


    })
    this.validations_caseState_form =new UntypedFormGroup({
      'file': new UntypedFormControl('', [Validators.required]),

    })

  }

  ngOnInit() {
    

    this.linkservice.fetchUserRole(this.localStorageSettings.getSettings("dnsName"), this.localStorageSettings.getSettings("AuthUsername")).subscribe(res => {
      console.log(res);
      this.responserequest = res;
    });

    /* modified by Chandra R
       *  calling the Userroles method to assign the rolenames for IDs in gride
       *  30-06-2024
    */
    let screenPath = this.userRoutingModule.print(this.constructor.name);
    this.retrieveScreenAccess.find(screenPath);
    this.linkservice.screenoperationspermission(screenPath, this.localStorageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      const buttonIdList: number[] = [];
      let responsedata: any;
      responsedata = res;
      for (let i = 0; i < responsedata.length; i++) {

        buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
      }

      console.log('Button ID List:', buttonIdList);
      const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
      buttons.forEach(button => {
        const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
        if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
          if (!buttonIdList.includes(buttonId)) {
            button.setAttribute('disabled', 'true'); // Disable the button
          } else {
            button.removeAttribute('disabled'); // Enable the button
          }
        }
        

        
      });
    });


    this.formvalidations();
    this.formvalidationproducttype();
    this.formvalidationCsv();
    this.retrieveObjectNames();
    this.columnDefsForObjects = [
      {
        headerName: "Tools",
        headerTooltip: "Tools",
        tooltipValueGetter: params => "Tools : " + params.value,

        filter: "agTextColumnFilter",
        width: 400,
        headerClass: 'headerClassName'
      }
    ];
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };


    this.columnDefs = [
      { headerName: 'Tool_Id', headerTooltip: 'ToolId', tooltipValueGetter: (params) => 'Tool Id : ' + params.value, field: 'toolCatalogueId', filter: 'agTextColumnFilter', width: 100 },
      {
        headerName: 'Tool_Name', headerTooltip: 'Tool Name', tooltipValueGetter: (params) => 'Tool Name : ' + params.value, field: 'toolName', filter: 'agTextColumnFilter', width: 250,
      },
    ]
    this.columnDefsForLog = [
      { headerName: "Service Log_Id", field: "serviceLogId", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Tool_Id", field: "toolId", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Activity Name", field: "activityName", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: " Service Start Date Time", field: "serviceStartDateTime", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: " Service End Date Time", field: "serviceEndDateTime", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Status", field: "status", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Executed By", field: "executedBy", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } }
    ]

    this.oracleColumns = [
  { headerName: "Service Log_Id", field: "serviceLogId", headerTooltip: "Service Log_Id", tooltipValueGetter: (params) => 'Service Log_Id : ' + params.value, resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
  { headerName: "Tool_Id", field: "toolId", headerTooltip: "Tool_Id", tooltipValueGetter: (params) => 'Tool Id : ' + params.value, resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
  { headerName: "Activity Name", field: "activityName", headerTooltip: "Activity Name", tooltipValueGetter: (params) => 'Activity Name : ' + params.value, resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
  { headerName: "Set Id", field: "setId", headerTooltip: "Set Id", tooltipValueGetter: (params) => 'Set Id : ' + params.value, resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
  { headerName: " Service Start Date Time", field: "serviceStartDateTime", headerTooltip: " Service Start Date Time", tooltipValueGetter: (params) => 'Service Start Date Time : ' + params.value, resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
  { headerName: " Service End Date Time", field: "serviceEndDateTime", headerTooltip: " Service End Date Time", tooltipValueGetter: (params) => 'Service End Date Time : ' + params.value, resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },    { headerName: "Status", field: "status", headerTooltip: "Status", tooltipValueGetter: (params) => 'Status : ' + params.value, resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
  { headerName: "Executed By", field: "executedBy", headerTooltip: "Executed By", tooltipValueGetter: (params) => 'Executed By : ' + params.value, resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
   {
        headerName: "Uploaded File",
        field: "uploadedfile",
        headerTooltip: "Uploaded File",

        resizable: true,
        filter: false,
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          docdownload: this.zipdownload.bind(this),
          downloadType: 'uploadedfile'
        },
        width: 220
      },
      {
        headerName: 'Download',
        field: 'downloadpath',
        headerTooltip: 'Download',
        filter: false,
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          docdownload: this.zipdownload.bind(this),
          downloadType: 'downloadpath'
        },
        width: 180
      }
]

    this.dataExtractor = [
      { headerName: "Service Log_Id", field: "serviceLogId", headerTooltip: "Service Log_Id", tooltipValueGetter: (params) => 'Service Log_Id : ' + params.value, resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Tool_Id", field: "toolId", headerTooltip: "Tool_Id", tooltipValueGetter: (params) => 'Tool Id : ' + params.value, resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Users", field: "user", headerTooltip: "Users", tooltipValueGetter: (params) => 'Users : ' + params.value, resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Activity Name", field: "activityName", headerTooltip: "Activity Name", tooltipValueGetter: (params) => 'Activity Name : ' + params.value, resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: " Service Start Date Time", field: "serviceStartDateTime", headerTooltip: " Service Start Date Time", tooltipValueGetter: (params) => 'Service Start Date Time : ' + params.value, resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: " Service End Date Time", field: "serviceEndDateTime", headerTooltip: " Service End Date Time", tooltipValueGetter: (params) => 'Service End Date Time : ' + params.value, resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Status", field: "status", headerTooltip: "Status", tooltipValueGetter: (params) => 'Status : ' + params.value, resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Executed By", field: "executedBy", headerTooltip: "Executed By", tooltipValueGetter: (params) => 'Executed By : ' + params.value, resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Total Counts", field: "totalcounts", headerTooltip: "Total Counts", tooltipValueGetter: (params) => 'Total Counts : ' + params.value, resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Pass Counts", field: "passcounts", headerTooltip: "Pass Counts", tooltipValueGetter: (params) => 'Pass Counts : ' + params.value, resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Fail Counts", field: "failcounts", headerTooltip: "Fail Counts", tooltipValueGetter: (params) => 'Fail Counts : ' + params.value, resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      {
        headerName: "Uploaded File",
        field: "uploadedfile",
        headerTooltip: "Uploaded File",

        resizable: true,
        filter: false,
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          docdownload: this.zipdownload.bind(this),
          downloadType: 'uploadedfile'
        },
        width: 220
      },
      {
        headerName: 'Result',
        field: 'downloadpath',
        headerTooltip: 'Result',
        filter: false,
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          docdownload: this.zipdownload.bind(this),
          downloadType: 'downloadpath'
        },
        width: 180
      },
      { headerName: "Machine ID", field: "machineid", headerTooltip: "Machine ID", tooltipValueGetter: (params) => 'Machine ID : ' + params.value, resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Data_Extraction_Master_ID", field: "dataExtractionMstrId", headerTooltip: "Data_Extraction_Master_ID", tooltipValueGetter: (params) => 'Data Extraction Master ID : ' + params.value, resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Retry Count", field: "retryCount", headerTooltip: "Retry Count", tooltipValueGetter: (params) => 'Retry Count : ' + params.value, resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
    ]


    this.columnDefsForxmlsplitter = [
      { headerName: "Service Log_Id", field: "serviceLogId", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Tool_Id", field: "toolId", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Activity Name", field: "activityName", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: " Service Start Date Time", field: "serviceStartDateTime", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: " Service End Date Time", field: "serviceEndDateTime", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Status", field: "status", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Executed By", field: "executedBy", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      {
        headerName: 'Download', filter: false, cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          docdownload: this.zipdownload.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 250
      }
    ]
/**
 * @author Abhishek
 * @Description This code is used to bind the data with Grid
 */
    this.columnDefsForR3Extractor = [
      { headerName: "Scheduled Job Id", field: "scheduledJobId", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Job Name", field: "scheduledJobName", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "initiated By", field: "username", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Vault Job Id", field: "vaultJobId", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Job Created Date Time", field: "jobCreatedDateTime", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Job Started Date time", field: "jobStartedDateTime", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Job Ended Date time", field: "jobEndedDateTime", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Job Status", field: "jobStatus", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Exception", field: "exception", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },      {
        headerName: 'Download', filter: false, cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          docdownload: this.downloadAndZipAnyFilesFromS3.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 250
      }
    ]

    this.columnDefsForcsvtosql = [
      { headerName: "Service Log_Id", field: "serviceLogId", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Tool_Id", field: "toolId", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Activity Name", field: "activityName", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: " Service Start Date Time", field: "serviceStartDateTime", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: " Service End Date Time", field: "serviceEndDateTime", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Status", field: "status", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } },
      { headerName: "Executed By", field: "executedBy", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' } }
    ]

    // Grid columns for R3XMLtoMySql
    this.columnDefsForR3XMLtoMySQL = [
      { headerName: "Service Log_Id", field: "serviceLogId", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' }, width: 150 },
      { headerName: "Tool_Id", field: "toolId", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' }, width: 120 },
      { headerName: "Activity Name", field: "activityName", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' }, width: 180 },
      { headerName: " Service Start Date Time", field: "serviceStartDateTime", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' }, width: 180 },
      { headerName: " Service End Date Time", field: "serviceEndDateTime", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' }, width: 180 },
      { headerName: "Status", field: "status", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' }, width: 150 },
      { headerName: "Executed By", field: "executedBy", resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' }, width: 180 },
      {
        headerName: 'Download', filter: false, cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          docdownload: this.zipdownload.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 200
      }
    ]

    this.columnDefsForState = [
      {
        headerName: 'Id', headerTooltip: 'Id', tooltipValueGetter: (params) => 'Id : ' + params.value, field: 'updatelifecycleid', filter: 'agTextColumnFilter', width: 200,
      },
      { headerName: "Tool_Id", field: 'toolid', resizable: true, cellStyle: { color: 'black', 'background-color': 'white', 'text-align': 'left' }
     },

      {
        headerName: 'FIle Name', headerTooltip: 'File Name', tooltipValueGetter: (params) => 'FIle Name : ' + params.value, field: 'fileName', filter: 'agTextColumnFilter', width: 200,
      },
      {
        headerName: 'Update Status', headerTooltip: 'Update Status', tooltipValueGetter: (params) => 'Update Status : ' + params.value, field: 'status', filter: 'agTextColumnFilter', width: 200,
      },
      {
        headerName: 'Start Date and Time', headerTooltip: 'Start Date and Time', tooltipValueGetter: (params) => 'Start Date and Time : ' + params.value, field: 'serviceStartDateTime', filter: 'agTextColumnFilter', width: 200,
      },
      {
        headerName: 'End Date and Time', headerTooltip: 'End Date and Time', tooltipValueGetter: (params) => 'End Date and Time : ' + params.value, field: 'serviceEndDateTime', filter: 'agTextColumnFilter', width: 200,
      },
      {
        headerName: 'Download', filter: false, cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          docdownload: this.docdownload.bind(this),
          //delete: this.deleteIcon.bind(this),
        }, width: 250
      }
    ]
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");


    //Calling Service and subscribe the data
    this.getToolsList();
    this.validations_form = this.fb.group({
      toolCatalogueId: '',
      toolName: '',
      endpoints: '',
      input: '',
      output: '',
      toolDescription: '',
      instructionToUse: '',
      usage: ''
    });
    this.validations_path_form =this.fb.group({
      toolCatalogueId:'',
      sourceFolder: '',
      destFolder: ''
    })
    this.validations_csvToSql_form =this.fb.group({
      toolCatalogueId:'',
      databasename: '',
      csvFileFolder: ''
    })
    this.validations_caseState_form =this.fb.group({
      file:null
    })


    this.toolDescriptionBinding = {};

  }



  setIdValidator(control: any) {
  const value = control.value;
  if (!value) return null;

  const regex = /^(\d+(,\d+)*)$|^(\d+-\d+)$/;

  return regex.test(value) ? null : { invalid: true };
}

  onPaginationChanged() {
    if (this.stateChange) {

      this.lastpage = this.stateChange.paginationIsLastPageFound();

      this.currentpage = this.stateChange.paginationGetCurrentPage() + 1

      this.nextpage = this.stateChange.paginationGetCurrentPage() + 1 + 1

      this.nextpageplusone = this.stateChange.paginationGetCurrentPage() + 1 + 1 + 1

      this.totalpages = this.stateChange.paginationGetTotalPages()

    }

  }
  //pagination code ends
  getToolsList(){
    this.spinner.start();
    this.migratorService.getTools().subscribe((data: Tool[]) => {
      // console.log(data);
      this.spinner.stop();
      this.tool = data;
      console.log(this.tool);
      this.onGridReadyForTools(this.grid)
    });
  }

  retrieveObjectNames(){
    this.spinner.start();
    let tableName = "objectmetadata"
    let coNameAndValue = "status = 'Yes' AND tenantid = "+ localStorage.getItem("dnsName")
    this.commonService.getlistByMultiplewhereclause(tableName,coNameAndValue).subscribe(response =>{
      console.log(response);
      this.objectNames = response;
      this.spinner.stop();
    });
  }

  //loading data to the toolGrid
  onGridReadyForTools(params) {
    this.toolsData = this.tool;
    console.log(this.toolsData);
    this.grid = params
    console.log(params)
    // this.gridApi = params.api;
    // console.log(params.api);
    this.grid.api.setGridOption('rowData', this.toolsData);
  }
// retrieving tool description and tool log
  retrieveToolData(e) {
    this.radiobutton=false;
    this.dataExtractorTool = false; 
    this.oracleToExcelToFtp = false;
    this.refreshVeevavault();
    this.temptooldata =e;
     this.toolCatalogueId=0;
    this.FormValidCsv.reset()
    this.FormValidR3Extractor.reset()
    this.statevaluechange={"fileName":"","fileData":"","path":"","action":"","databasename":"","actioName":"","userAction":"","objectName":"",noOfRecord: 0, "isSplited":this.isSplited}
    this.validations_path_form.reset();
     console.log(e);
    // getting perticular row data
    let toolData = e.data;
   // storing perticular row data to toolData
    console.log(toolData);
    // Stroing the id data to the empty object
    this.toolDescriptionBinding = {}
    //Accesing the data of the perticular id from the json
    this.toolDescriptionBinding = toolData;
    this.toolname = this.toolDescriptionBinding.toolName;
    console.log(this.toolDescriptionBinding)
    //checking id for csvToSql tool
    if (this.toolDescriptionBinding.toolCatalogueId == '9') {
      this.csvToSql = true;
      this.caseState=false;
      this.producttypeupdate = false
      this.xmlcase = false;
     // this.migrationtooltemplate=false;

      this.xmlsplitter = false
      this.R3xmlExtraction=false;
      this.R3xmltoMySQL = false;
      this.toolCatalogueId = this.toolDescriptionBinding.toolCatalogueId;
      console.log(this.csvToSqlToolDescriptionModel.toolCatalogueId);
    }else if( this.toolDescriptionBinding.toolCatalogueId == '1'){
      this.csvToSql = false;
      this.caseState=false;
      this.producttypeupdate = false;

     // this.migrationtooltemplate=false;

      this.xmlcase = true;
      this.xmlsplitter = false;
      this.R3xmlExtraction=false;
      this.R3xmltoMySQL = false;
      this.toolCatalogueId = this.toolDescriptionBinding.toolCatalogueId;
    }
    // R3XML to MySQL tool code. Implemneted by kalpesh on 29-jul-22
    else if(this.toolDescriptionBinding.toolCatalogueId == '13'){
      this.R3xmltoMySQL = true;
      this.csvToSql = false;
      this.caseState=false;
      this.producttypeupdate = false
      this.xmlcase = false;
      this.xmlsplitter = false;
      this.R3xmlExtraction=false;
      this.toolCatalogueId = this.toolDescriptionBinding.toolCatalogueId;
    }
    else if(this.toolDescriptionBinding.toolCatalogueId == '3'){
      this.csvToSql = false;
      this.caseState=false;
      this.producttypeupdate = false
      this.xmlcase = false;
      this.xmlsplitter = true;

      //this.migrationtooltemplate=true;
      this.radiobutton=true;

      this.csvsplitter=false;
      this.R3xmlExtraction=false;
      this.R3xmltoMySQL = false;
      this.toolCatalogueId = this.toolDescriptionBinding.toolCatalogueId;
    }
    else if(this.toolDescriptionBinding.toolCatalogueId == '11'){
      this.csvToSql = false;
      this.caseState=false;
      this.producttypeupdate = true;
      this.xmlcase = false;
      this.xmlsplitter = false;
      this.R3xmlExtraction=false;
      this.R3xmltoMySQL = false;
      this.toolCatalogueId = this.toolDescriptionBinding.toolCatalogueId;
      this.onGridReadyProductTypeChange(this.stateChange,this.toolCatalogueId);
    }
    else if(this.toolDescriptionBinding.toolCatalogueId == '5'){
      this.csvToSql = false;
      this.caseState=false;
      this.producttypeupdate = false
      this.xmlcase = false;
      this.xmlsplitter = true;
      this.csvsplitter=true;
      this.R3xmlExtraction=false;
      this.R3xmltoMySQL = false;
      this.toolCatalogueId = this.toolDescriptionBinding.toolCatalogueId;
    }
    // Code for R3 extractor tool
    else if(this.toolDescriptionBinding.toolCatalogueId == '12'){
      this.csvToSql = false;
      this.caseState=false;
      this.producttypeupdate = false
      this.xmlcase = false;
      this.xmlsplitter = false;
      this.csvsplitter=false;
      this.R3xmlExtraction=true;
      this.R3xmltoMySQL = false;
      this.onGridReadyForR3Extractor(this.R3API);
      this.toolCatalogueId = this.toolDescriptionBinding.toolCatalogueId;
    }
    else if (this.toolDescriptionBinding.toolCatalogueId == '2' || this.toolDescriptionBinding.toolCatalogueId == '4' || this.toolDescriptionBinding.toolCatalogueId == '5' || this.toolDescriptionBinding.toolCatalogueId == '6' || this.toolDescriptionBinding.toolCatalogueId == '7' || this.toolDescriptionBinding.toolCatalogueId == '8' || this.toolDescriptionBinding.toolCatalogueId == '14') {
      this.csvToSql = false;
      this.caseState=false;
      this.producttypeupdate = false
      this.xmlcase = false;

      this.xmlsplitter = true;
      this.radiobutton=false;
      //this.migrationtooltemplate=false;

      this.csvsplitter=false;
      this.R3xmlExtraction=false;
      this.R3xmltoMySQL = false;
      this.toolCatalogueId = this.toolDescriptionBinding.toolCatalogueId;
    }
    // else if(this.toolDescriptionBinding.toolCatalogueId == '2' || this.toolDescriptionBinding.toolCatalogueId == '4' || this.toolDescriptionBinding.toolCatalogueId == '5' || this.toolDescriptionBinding.toolCatalogueId == '6' || this.toolDescriptionBinding.toolCatalogueId == '7' || this.toolDescriptionBinding.toolCatalogueId == '8') {
    //   this.csvToSql = false;
    //   this.caseState=false;
    //   this.producttypeupdate = false
    //   this.xmlcase = false;
    //   this.xmlsplitter = true;
    //   this.csvsplitter=false;
    //   this.R3xmlExtraction=false;
    //   this.R3xmltoMySQL = false;
    //   this.toolCatalogueId = this.toolDescriptionBinding.toolCatalogueId;
    // }



    else if(this.toolDescriptionBinding.toolName == 'Data Extractor'){

  this.dataExtractorTool = true;

  this.csvToSql = false;
  this.caseState = false;
  this.producttypeupdate = false;
  this.xmlcase = false;
  this.xmlsplitter = false;
  this.R3xmlExtraction = false;
  this.R3xmltoMySQL = false;

  this.radiobutton = true;   
  this.csvsplitter = false;

  this.toolCatalogueId = this.toolDescriptionBinding.toolCatalogueId;

  this.retrieveDashboardCounts();

}
else if(this.toolDescriptionBinding.toolName == 'Oracle To Excel To FTP'){   

  this.oracleToExcelToFtp = true;
  this.csvToSql = false;
  this.caseState = false;
  this.producttypeupdate = false;
  this.xmlcase = false;
  this.xmlsplitter = false;
  this.R3xmlExtraction = false;
  this.R3xmltoMySQL = false;

  this.toolCatalogueId = this.toolDescriptionBinding.toolCatalogueId;

}


 else{
   this.caseState= true;
   this.csvToSql = false;
   this.producttypeupdate = false
  this.xmlcase = false;
  this.xmlsplitter = false;
  this.R3xmlExtraction = false;
  this.R3xmltoMySQL = false;
   this.onGridReadyStateChange(this.stateChange,10);

 }
 this.toolDescriptionModel.toolCatalogueId = this.toolDescriptionBinding.toolCatalogueId;
 console.log(this.toolDescriptionModel.toolCatalogueId);
    //calling service for ag grid
     this.retrieveToolLogueData();
  }

retrieveToolLogueData(){
  this.spinner.start();

  // if Data Extractor tool
  if(this.toolDescriptionBinding.toolName == 'Data Extractor'){
      this.migratorService.getCaseAuditRefresh().subscribe(res => {
              this.logData = res;
              this.onGridReadyForLog(this.logGrid);
              this.spinner.stop();
          });
  }
  else if(this.toolDescriptionBinding.toolName == 'Oracle To Excel To FTP'){  

    this.migratorService.refreshOracle().subscribe(res => {
      this.logData = res;
      this.onGridReadyForLog(this.logGrid);
      this.spinner.stop();
    });

  }
  else{
      this.migratorService.getToolLog(this.toolDescriptionBinding.toolCatalogueId).subscribe(res => {
              this.logData = res;
              this.onGridReadyForLog(this.logGrid);
              this.spinner.stop();
          });
  }
}


retrieveDashboardCounts() {

  this.migratorService.getDataExtractorUsernameConfig()
    .subscribe((response: any) => {
this.dashboardCounts.currentStatus = response.status;
      this.dashboardCounts.totalSets = response.totalSets;
      this.dashboardCounts.queuedSets = response.queuedSets;
      this.dashboardCounts.inProgressSets = response.inProgressSets;
      this.dashboardCounts.completedSets = response.completedSets;
      this.dashboardCounts.failedSets = response.failedSets;
      this.dashboardCounts.remainingSets = response.remainingSets;

      this.dashboardCounts.totalCases = response.totalCases;
      this.dashboardCounts.casesInProgress = response.inProgressCases;
      this.dashboardCounts.casesCompleted = response.completedCases;
      this.dashboardCounts.casesFailed = response.failedCases;
      this.dashboardCounts.casesRemaining = response.remainingCases;

    });
}


openUsernameConfigDialog() {

  const currentRun = this.logData.find(x => x.status === 'In Progress');

  if (!currentRun) {
    this.snackBar.open(
      'No Data Extraction run is currently in progress.',
      'OK',
      { duration: 5000 }
    );
    return;
  }

  this.dialog.open(UsernameConfigurationComponent, {
    width: '45%',
    disableClose: true,
    autoFocus: false,
    data: {
      runId: currentRun.dataExtractionMstrId
    }
  });

}

  //loading data to ag grid for logdata
  onGridReadyForLog(params) {
    this.toolsLogData = this.logData;
    console.log(this.toolsLogData);
    this.logGrid = params;
    console.log(params)
    this.gridApi = params.api;
    console.log(params.api);
    if(this.toolsLogData.length===0){
      this.logGrid.api.setGridOption('rowData', []);
    }else{
    this.logGrid.api.setGridOption('rowData', this.toolsLogData);
    }
    this.spinner.stop();
  }

  formvalidations() {
    this.FormValid = new UntypedFormGroup({
      imageName: new UntypedFormControl(""),
      imageupload: new UntypedFormControl(""),
      action:new UntypedFormControl("",[Validators.required]),
      objectName: new UntypedFormControl("",[Validators.required]),
    });
  }

  formvalidationproducttype(){
    this.FormValidProductType = new UntypedFormGroup({
        imageName: new UntypedFormControl(""),
        imageupload: new UntypedFormControl(""),
        objectName: new UntypedFormControl("",[Validators.required]),
      });
  }
  formvalidationCsv() {
    this.FormValidCsv = new UntypedFormGroup({
      imageName: new UntypedFormControl(""),
      imageupload: new UntypedFormControl(""),
      action:new UntypedFormControl(""),
      databasename:new UntypedFormControl("",[Validators.required,Validators.pattern('^[a-zA-Z_][a-zA-Z0-9_]*$')]),
      isSplited: new UntypedFormControl(""),
      noOfRecord: new UntypedFormControl(""),
    });

    this.FormValidOracle = new UntypedFormGroup({
  setId: new UntypedFormControl("", [Validators.required, this.setIdValidator]),
  imageName: new UntypedFormControl("", Validators.required),
  imageupload: new UntypedFormControl("", Validators.required)
});
    // formvalidation for R3Extractor
    this.FormValidR3Extractor = new UntypedFormGroup({
      imageName: new UntypedFormControl(""),
      imageupload: new UntypedFormControl(""),
    });
    this.FormValidCaseAudit = new UntypedFormGroup({

       // kept for backward-compatibility (UI currently comments Activity Name)
      activityName: new UntypedFormControl(""),

      // Source CSV file controls
      sourceFileName: new UntypedFormControl("", Validators.required),
      sourceFileUpload: new UntypedFormControl("", Validators.required),

      // Template file controls
      templateFileName: new UntypedFormControl("", Validators.required),
      templateFileUpload: new UntypedFormControl("", Validators.required),

      // Text fields
 splitCount: new UntypedFormControl('', [
    Validators.required,
    Validators.min(1),
    Validators.max(1000)
]),
maxRetry: new UntypedFormControl('', [
    Validators.required,
    Validators.min(1),
    Validators.max(5)
]),
      validationRequired: new UntypedFormControl(false),
      userName: new UntypedFormControl("", Validators.required),
      failedUserName: new UntypedFormControl("", Validators.required),
      // legacy fields (left present to avoid breaking references elsewhere)
      imageName: new UntypedFormControl(""),
      imageupload: new UntypedFormControl("")

    });
  }
   // to encode the selected photozipfileextraction
   readThisimage(inputValue: any,filecheck:any): void {
     let ischeckfile=false
    var file: File = inputValue.files[0];
    var FileS: File = inputValue.files[0];
    console.log("file type")
    console.log(file.type)
    let flag:boolean= this.commonTs.hasMultipleExtensions(file);
     if (filecheck === 'zip') {
      console.log("inside zip")
      if (file.type === 'application/x-zip-compressed'){
        ischeckfile = true
        console.log("inside application")

      }
      else if (file.type =='application/zip'){
        ischeckfile = true;
        console.log("inside application/zip")

      }
     } else {
       console.log("inside else")

       if (file.type === 'text/csv' || file.type === 'application/vnd.ms-excel' ||
 file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
         console.log("inside text/csv")
        ischeckfile=true
      }
     }
     console.log(this.toolDescriptionBinding.toolCatalogueId == '2');
     if (file.type === 'text/csv' && this.toolDescriptionBinding.toolCatalogueId == '14') {
       console.log("inside text/csv 14")
       ischeckfile = true
     }
    if (!flag&&ischeckfile) {
      console.log(file.size / 1000)
      var size = file.size / 1000
      /**
       * Modified by Ashwin M
       * 27/02/2023
       * code modified to increase file upload size limit to 200MB
       */
      if (size <= 500000) {
            var fileName = FileS.name;
            //var filename = (<HTMLInputElement>document.getElementById('file-id')).value;
            this.spinner.start(); 
            var photo: FileReader = new FileReader();
            photo.onloadend = e => {
              var img = photo.result;
              console.log(photo.result);
              var photobase64result = photo.result.toString().split(",", 2)[1];
console.log(photobase64result)
              // this is to check the file is empty or not
              if (photobase64result == null) {

              } else {
                this.imagephoto = photo.result.toString();
                this.imagephotoshow = true;
                this.statevaluechange.fileData = photobase64result;
                this.statevaluechange.fileName = fileName;
                this.FormValidProductType.controls.imageName.setValue(fileName);
                this.FormValidCsv.controls.imageName.setValue(fileName);
                console.log(this.statevaluechange)
                // (<HTMLInputElement>document.getElementById('file-path')).value= fileName;
              }
            };
                photo.readAsDataURL(file);
                this.spinner.stop();
      } else {
        this.snackBar.open("Selected file " + file.name + ", size should be less than 200MB", "OK", {
          duration: 5000,
        });
      }
    } else {
      this.snackBar.open(file.name + " is a invalid file type ", "OK", {
        duration: 5000,
      });
    }
  }
  imagePhotofunction($event,filecheck): void {
    this.readThisimage($event.target,filecheck);
  }


  imagePhotofunctionState($event): void {
    this.readThisimageState($event.target);
  }

  // input file validation code for R3 extractor start
  imagePhotofunctionR3($event): void {
    this.readThisimageR3($event.target);
  }

  readThisimageR3(inputValue: any): void{
    let ischeckfile=false
    var file: File = inputValue.files[0];
    var FileS: File = inputValue.files[0];
    console.log(file.type)
    let flag:boolean= this.commonTs.hasMultipleExtensions(file);
     if (file.type === 'text/csv'){
      ischeckfile=true;
     }
     if(!flag&&ischeckfile){
      console.log(file.size)
      console.log(file.size / 1000)
      var size = file.size / 1000
      if (size <= 25072) {
            var fileName = FileS.name;
            //var filename = (<HTMLInputElement>document.getElementById('file-id')).value;

            var photo: FileReader = new FileReader();
            photo.onloadend = e => {
              var img = photo.result;
              console.log(photo.result);
              var photobase64result = photo.result.toString().split(",", 2)[1];

              // this is to check the file is empty or not
              if (photobase64result == null) {

              } else {
                this.imagephoto = photo.result.toString();
                this.imagephotoshow = true;
                this.statevaluechange.fileData = photobase64result;
                this.statevaluechange.fileName = fileName;
                this.FormValidR3Extractor.controls.imageName.setValue(fileName);
                console.log(this.statevaluechange)
                // (<HTMLInputElement>document.getElementById('file-path')).value= fileName;
              }
          };
                photo.readAsDataURL(file);
     } else {
       this.snackBar.open("Selected file " + file.name + ", size should be less than 3MB", "OK", {
         duration: 5000,
       });
     }
   } else {
     this.snackBar.open(file.name + " is a invalid file type. Please select CSV file.", "OK", {
       duration: 5000,
     });
   }
  }
  // input file validation code for R3 extractor end
  // to encode the selected photo
  readThisimageState(inputValue: any): void {
    console.log(this.statevaluechange.objectName)
    if(this.statevaluechange.objectName === ""){
      this.snackBar.open("Please select Object Name", "OK", {
        duration: 5000,
      });
      this.refresh();
    }else{
    let ischeckfile=false
   var file: File = inputValue.files[0];
   var FileS: File = inputValue.files[0];
   console.log(file.type)
   let flag:boolean= this.commonTs.hasMultipleExtensions(file);
     if (!flag&&(file.type === 'text/csv' || file.type ==='application/vnd.ms-excel')){

      console.log(file.size)
      console.log(file.size / 1000)
      var size = file.size / 1000
      if (size <= 25072) {
            var fileName = FileS.name;
            //var filename = (<HTMLInputElement>document.getElementById('file-id')).value;

            var photo: FileReader = new FileReader();
            photo.onloadend = e => {
              var img = photo.result;
              console.log(photo.result);
              var photobase64result = photo.result.toString().split(",", 2)[1];

              // this is to check the file is empty or not
              if (photobase64result == null) {

              } else {
                this.imagephoto = photo.result.toString();
                this.imagephotoshow = true;
                this.statevaluechange.fileData = photobase64result;
                this.statevaluechange.fileName = fileName;
                this.FormValid.controls.imageName.setValue(fileName);
                console.log(this.statevaluechange)
                this.getActionItems();
                // (<HTMLInputElement>document.getElementById('file-path')).value= fileName;
              }
          };
                photo.readAsDataURL(file);
     } else {
       this.snackBar.open("Selected file " + file.name + ", size should be less than 3MB", "OK", {
         duration: 5000,
       });
     }
   } else {
     this.snackBar.open(file.name + " is a invalid file type ", "OK", {
       duration: 5000,
     });
   }
  }
 }

// async lookupValue(){
//   let response = await this.commonService.retrieveSingleRecordService("lookupvalue", "lookuptypeid", 31);
//   console.log(response);
//   this.actionDetails = response;
// }

getActionItems(){
  this.spinner.start();
  console.log(this.statevaluechange.fileData)
 if(this.statevaluechange.fileData===null || this.statevaluechange.fileData===undefined || this.statevaluechange.fileData==='')  {
this.snackBar.open(this.constants.noCsvFileSelected, "OK", {
  panelClass: 'snack'
}
);
this.spinner.stop();
}
else{
  this.migratorService.getActionItems(this.statevaluechange,this.localStorageSettings.getSettings("vaultDnsname")).subscribe(response =>{
    console.log(response);
    this.actionDetails = response;
    this.spinner.stop();
  });
}
}

updateproducttype(){
  this.spinner.start();
      console.log(this.statevaluechange.fileData)
     if(this.statevaluechange.fileData===null || this.statevaluechange.fileData===undefined || this.statevaluechange.fileData==='')  {
    this.snackBar.open(this.constants.noCsvFileSelected, "OK", {
      panelClass: 'snack'
    }
    );
    this.spinner.stop();
  }
  else{
    if (!this.FormValidProductType.valid) {
      // displaying validation messages
      this.validation.validateAllFormFields(this.FormValidProductType);
      this.validation.getvalidationmessage();
      this.spinner.stop();
      return
    }else{
      this.migratorService.updateProductTypeService(this.statevaluechange,this.localStorageSettings.getSettings("vaultDnsname"),this.localStorageSettings.getSettings("dnsName")).subscribe(response =>{
        console.log(response);
        // checking if response is true or not
    if (response.error == true) {
      this.spinner.stop();
      this.snackBar.open(response.statusMessage, "OK", {
        duration: 5000,
      });

    } else {
      this.spinner.stop();
      console.log(response)
      this.snackBar.open(response.statusMessage, "OK", {
        duration: 5000,
      });
      this.actionDetails=[];

    }
      });
    }

  }
  this.refresh();
  this.spinner.stop();
}

     uploadFileToActivity(){
      this.spinner.start();
      console.log(this.statevaluechange.fileData)
     if(this.statevaluechange.fileData===null || this.statevaluechange.fileData===undefined || this.statevaluechange.fileData==='')  {
    this.snackBar.open(this.constants.noCsvFileSelected, "OK", {
      panelClass: 'snack'
    }
    );
    this.spinner.stop();
  }else if(this.statevaluechange.actioName===null || this.statevaluechange.actioName===undefined || this.statevaluechange.actioName==='')  {
    this.snackBar.open(this.constants.noUserActions, "OK", {
      panelClass: 'snack'
    }
    );
    this.spinner.stop();
  }
  else if(this.statevaluechange.actioName==='No User Actions to Perform or Please check the csv format.')  {
    this.snackBar.open(this.constants.noUserActions, "OK", {
      panelClass: 'snack'
    }
    );
    this.spinner.stop();
  }
  else{
    if (!this.FormValid.valid) {
      // displaying validation messages
      this.validation.validateAllFormFields(this.FormValid);
      this.validation.getvalidationmessage();
      this.spinner.stop();
      return
    } else{
      this.migratorService.postFile(this.statevaluechange,this.localStorageSettings.getSettings("vaultDnsname"),this.localStorageSettings.getSettings("dnsName")).subscribe(response =>{
        console.log(response);
        // checking if response is true or not
    if (response.error == true) {
      this.spinner.stop();
      this.snackBar.open(response.statusMessage, "OK", {
        duration: 5000,
      });

    } else {
      this.spinner.stop();
      console.log(response)
      this.snackBar.open(response.statusMessage, "OK", {
        duration: 5000,
      });
      this.actionDetails=[];

    }
      });

    }
  }
  this.refresh();
  this.spinner.stop();
}

  uploadR3Csvfile(){
    this.spinner.start();
      console.log(this.statevaluechange.fileData)
      console.log(this.statevaluechange.fileName)
      this.statevaluechange.path = "C:\\uploads\\jmigrator\\XmlExtractor"
      console.log(this.statevaluechange.path);
      if(this.statevaluechange.fileData===null || this.statevaluechange.fileData===undefined || this.statevaluechange.fileData==='')  {
      this.snackBar.open(this.constants.noCsvFileSelected, "OK", {
        panelClass: 'snack'
      }
      );
      this.spinner.stop();
      }
      else{
        this.migratorService.uploadR3Extractor(this.statevaluechange).subscribe(response =>{
          console.log(response);
          // checking if response is true or not
        if (response.error == true) {
          this.spinner.stop();
          this.snackBar.open(response.statusMessage, "OK", {
            duration: 5000,
          });

        } else {
        console.log(response)
        this.snackBar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        this.refresh();
        this.spinner.stop();
        }
        });
        this.spinner.stop();
      }
  }

  uploadZipFile() {
  console.log(this.isSplited);
  this.statevaluechange.isSplited = this.isSplited;
  console.log(this.statevaluechange);
  this.spinner.start();
  console.log(this.toolCatalogueId)

if(this.toolCatalogueId===3){
  //console.log("asdfghjhgfdsdfghjkjhgfdsdfghjk");


  let obj={...this.statevaluechange,xmlType:this.xmlType};
  this.statevaluechange=obj;
  //console.log(this.statevaluechange);

}

 if(this.toolCatalogueId===5){
   if(this.statevaluechange.fileData===null || this.statevaluechange.fileData===undefined || this.statevaluechange.fileData==='')  {
     this.snackBar.open(this.constants.noFileSelected, "OK", {
         panelClass: 'snack', duration: 5000
       }
     );
     this.spinner.stop();
   }
   else if(this.statevaluechange.noOfRecord===null || this.statevaluechange.noOfRecord===undefined || this.statevaluechange.noOfRecord===0){
     this.snackBar.open(this.constants.noRecordSeleted, "OK", {
         panelClass: 'snack', duration: 5000
       }
     );
     this.spinner.stop();
   }
   else if(this.statevaluechange.noOfRecord < 1000){
     this.snackBar.open(this.constants.minRecord, "OK", {
         panelClass: 'snack', duration: 5000
       }
     );
     this.spinner.stop();
   }
   else {
     this.migratorService.postZipFile(this.statevaluechange, this.toolCatalogueId, localStorage.getItem("WorkspaceId")).subscribe(response =>{
       console.log(response);
       // checking if response is true or not
       if (response.error == true) {
         this.snackBar.open(response['statusMessage'], "OK", {
           duration: 5000,
         });

       } else {

         console.log(response)
         this.snackBar.open(response['message'], "OK", {
           duration: 5000,
         });
         this.refresh()
       }
       this.spinner.stop();
     });

     //}
     this.refresh()
   }
 }
 else if(this.toolCatalogueId==3&& this.xmlType==null){
  //console.log("asdfghjhgfdsdfghjkjhgfdsdfghjk");
  this.snackBar.open(this.constants.selectR2XMLorR3XML, "OK", {
    panelClass: 'snack', duration: 5000
  }
);
this.spinner.stop();
}

 else if (this.statevaluechange.fileData === null || this.statevaluechange.fileData === undefined || this.statevaluechange.fileData === '') {
   if (this.toolCatalogueId == 14) {
     this.snackBar.open("Please select the CSV File", "OK", {
       panelClass: 'snack', duration: 5000
     }
     );
     this.spinner.stop();
   } else {
     this.snackBar.open(this.constants.noFileSelected, "OK", {
       panelClass: 'snack', duration: 5000
     }
     );
     this.spinner.stop();
   }
 
}
else{

  if(this.toolCatalogueId===9 || this.toolCatalogueId===1 || this.toolCatalogueId===13){
    if(this.statevaluechange.databasename===null || this.statevaluechange.databasename===undefined || this.statevaluechange.databasename==='')  {
      this.snackBar.open(this.validation_messages.databasename[0].message, "OK", {
        panelClass: 'snack', duration: 5000
      }
      );
      this.spinner.stop();
      return;
    }
    else if (!this.FormValidCsv.get('databasename').valid ){
      this.snackBar.open(this.validation_messages.databasename[3].message, "OK", {
          panelClass: 'snack', duration: 5000
        }
      );
      this.spinner.stop();
      return;
    }
  }
  console.log(this.statevaluechange)
 //if(confirm(this.constants.confirmMessageForUpdateCaseState)){
   console.log("WorkspaceId -"+ localStorage.getItem("WorkspaceId"))
   this.migratorService.postZipFile(this.statevaluechange, this.toolCatalogueId, localStorage.getItem("WorkspaceId")).subscribe(response =>{
     console.log(response);
     // checking if response is true or not
     if (response.error == true) {
       this.snackBar.open(response['statusMessage'], "OK", {
         duration: 5000,
       });

     } else {
       console.log(response)
       this.snackBar.open(response['message'], "OK", {
         duration: 5000,
       });
       this.isSplited = false;
      this.refresh()
     }
     this.spinner.stop();
   });

 //}
 this.refresh()
}
}

/**
 * @author Abhishek
 * @description This code is used to download the Zip file for R3Xml Extractor
 * @param e
 */
downloadAndZipAnyFilesFromS3(e){
  console.log(e.rowData)
  console.log(this.restApi.zipanddownloadanyfilesFromS3+"/"+e.rowData.downloadpath+"/XmlExtractor")
  this.zipDoc = this.restApi.zipanddownloadanyfilesFromS3+"/"+e.rowData.downloadpath+"/XmlExtractor";
  if(e.rowData.downloadpath===undefined || e.rowData.downloadpath=== "" || e.rowData.downloadpath ===null){
    this.snackBar.open("Please Wait till the process is completed.", "OK", {
      panelClass: 'snack'
    }
    );
  }else{
    this.spinner.start();
  this.migratorService.download_zip(this.zipDoc)
    .subscribe(x => {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([x],{type:'application/zip'});

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      //   window.navigator.msSaveOrOpenBlob(newBlob);
      //   return;
      // }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);
      console.log(data)
      var link = document.createElement('a');
      link.href = data;
      console.log(e.rowData.fileName)
      link.download = "converted.zip";
      console.log("ento")
      // this is necessary as link.click() does not work on the latest firefox
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);
    });
    this.spinner.stop();
  }
}


zipDoc
  zipdownload(e) {
    console.log(e.rowData)
    if (e.rowData.activityName === "Narrative Preview Generator") {
      this.zipDoc = this.restApi.zipanddownloadanyfilesFromS3 + "/" + e.rowData.downloadpath;
    } 
   else if (this.oracleToExcelToFtp) {
  const downloadType = e.downloadType || 'downloadpath';

  if (downloadType === 'uploadedfile') {
    const s3Path = e.rowData.uploadedfile;

    if (!s3Path) {
      this.snackBar.open("File does not exist.", "OK", { duration: 4000 });
      return;
    }

    const cleanPath = s3Path.replace(/\/+$/, '');
    const fileName = cleanPath.split('/').pop() || 'download.xlsx';
    const requestBody = JSON.stringify({ s3Path: cleanPath });

    this.spinner.start();
    this.httpClient.post(this.restApi.DOWNLOADFILEFROMS3, requestBody, {
        headers: { 'Content-Type': 'application/json' },
        responseType: 'blob'
      })
      .subscribe(blob => {
        if (!blob || blob.size === 0) {
          this.snackBar.open('File not found or error from server.', 'OK', { duration: 5000 });
          this.spinner.stop();
          return;
        }
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        setTimeout(() => { window.URL.revokeObjectURL(url); link.remove(); }, 100);
        this.spinner.stop();
      }, err => {
        console.error('Excel download failed:', err);
        this.snackBar.open('Download failed.', 'OK', { duration: 5000 });
        this.spinner.stop();
      });
    return;
  }

  const folderPath = e.rowData.downloadpath;
  console.log('Oracle zip folder path:', folderPath);

  if (!folderPath) {
    this.snackBar.open("File does not exist.", "OK", { duration: 4000 });
    return;
  }

  const cleanFolderPath = folderPath.replace(/\/+$/, '');

  this.zipDoc = this.restApi.zipanddownloadanyfilesFromS3 + "/" + cleanFolderPath;
  console.log('Oracle zip URL:', this.zipDoc);

  this.spinner.start();
  this.migratorService.download_zip(this.zipDoc).subscribe(x => {
    const newBlob = new Blob([x], { type: 'application/zip' });
    console.log('Oracle zip blob size:', newBlob.size);

    if (newBlob.size < 100) {
      const reader = new FileReader();
      reader.onload = () => console.error('Backend error response:', reader.result);
      reader.readAsText(newBlob);
      this.snackBar.open('Empty or invalid zip received from server.', 'OK', { duration: 5000 });
      this.spinner.stop();
      return;
    }

    const data = window.URL.createObjectURL(newBlob);
    const link = document.createElement('a');
    link.href = data;
    link.download = 'oracle_export.zip';
    link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    setTimeout(() => { window.URL.revokeObjectURL(data); link.remove(); }, 100);
    this.spinner.stop();
  }, err => {
    console.error('Oracle zip download error:', err);
    this.snackBar.open('Download failed.', 'OK', { duration: 5000 });
    this.spinner.stop();
  });

  return;
}
     else if (this.dataExtractorTool) {
      const downloadType = e.downloadType || 'downloadpath';
      const s3Path =
        downloadType === 'uploadedfile'
          ? e.rowData.uploadedfile
          : e.rowData.downloadpath;

      if (!s3Path) {
        this.snackBar.open("File does not exist.", "OK", { duration: 4000 });
        return;
      }

       console.log('s3Path being sent:', s3Path);


      // Strip trailing slashes, then extract filename
      const cleanPath = s3Path.replace(/\/+$/, '');
      const fileName = cleanPath.split('/').pop() || 'download';
      const requestBody = JSON.stringify({ s3Path: s3Path });

      this.spinner.start();

      this.httpClient.post(this.restApi.DOWNLOADFILEFROMS3, requestBody, {
          headers: { 'Content-Type': 'application/json' },
          responseType: 'blob'
        })
        .subscribe(blob => {
          if (!blob || blob.size === 0) {
            console.error('Empty download blob for', s3Path);
            this.snackBar.open('Download returned empty content.', 'OK', { duration: 5000 });
            this.spinner.stop();
            return;
          }

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
          setTimeout(() => {
            window.URL.revokeObjectURL(url);
            link.remove();
          }, 100);
          this.spinner.stop();
        }, err => {
          console.error('S3 download failed', err);
          this.snackBar.open('Download failed. Please check your connection.', 'OK', { duration: 5000 });
          this.spinner.stop();
        });

      return;
    } else {
      this.zipDoc = e.rowData.downloadpath
    }
  
  if(e.rowData.downloadpath===undefined || e.rowData.downloadpath=== "" || e.rowData.downloadpath ===null){
      if(e.rowData.toolId=== 3){
        this.snackBar.open("Please verify the status is completed.", "OK", {
          panelClass: 'snack', duration: 5000
        });

      }
      else{
        this.snackBar.open("Please Wait till the process is completed.", "OK", {
          panelClass: 'snack', duration: 5000
        });

      }
  }else{
    this.spinner.start();
  this.migratorService.download_zip(this.zipDoc)
    .subscribe(x => {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([x],{type:'application/zip'});

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      //   window.navigator.msSaveOrOpenBlob(newBlob);
      //   return;
      // }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);
      console.log(data)
      var link = document.createElement('a');
      link.href = data;
      console.log(e.rowData.fileName)
      link.download = "converted.zip";
      console.log("ento")
      // this is necessary as link.click() does not work on the latest firefox
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);
    });
    this.spinner.stop();
  }
}

Doc
docdownload(e) {
  console.log(e.rowData)
  this.Doc = e.rowData.csvfilepath
  if(this.Doc===undefined || this.Doc=== "" || this.Doc ===null){
    this.snackBar.open("Please Wait till the process is completed.", "OK", {
      panelClass: 'snack'
    });
  }else{
    this.spinner.start();
  this.migratorService.download_test(this.Doc)
    .subscribe(x => {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([x]);

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      //   window.navigator.msSaveOrOpenBlob(newBlob);
      //   return;
      // }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);

      var link = document.createElement('a');
      link.href = data;
      link.download = e.rowData.fileName;
      // this is necessary as link.click() does not work on the latest firefox
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);
    });
    this.spinner.stop();
  }
}

async lookUpType(e){
  console.log(e)
  this.statevaluechange.userAction = e.value.name
  this.statevaluechange.actioName = e.value.lable
  console.log(this.statevaluechange)
}

async selectedObjectlabel(e){
  this.statevaluechange.objectName = e.value
}

refresh(){
  this.actionDetails=[];
  console.log(this.temptooldata)
  if(this.temptooldata!==undefined){
  this.retrieveToolData(this.temptooldata);
  }
  this.formvalidations()
  this.formvalidationproducttype()
  this.formValidation()
  this.formvalidationCsv()
}

refreshVeevavault(){
  this.actionDetails=[];
  this.formvalidations()
  this.formvalidationproducttype()
  this.formValidation()
  this.formvalidationCsv()
}

  //sending toolid,csvFileFolder and databaseName for CsvToSql Tool
  send() {

    if (this.csvToSqlToolDescriptionModel.toolCatalogueId == '9') {
      if(confirm(this.constants.confirmMessageForCsvToSql)){
      console.log(this.csvToSqlToolDescriptionModel);

      this.migratorService.csvToSql(this.csvToSqlToolDescriptionModel).subscribe(res => {
        console.log(res);
        this.validations_csvToSql_form.reset();
        // response from server that user can also get in the ui screen it will go back after 5sec

        this.snackBar.open(res.message, "OK", {
          panelClass: 'snack'
        }
        );
        this.validations_path_form.reset();
        this.gridData();
      });

    }
  }


}


// sending toolCatalogueId, sourceFolder and destinationFolder to all Tools except csvToSql
  save() {
    //  if user is  not selcted a tool any tool
    if(this.toolDescriptionModel.toolCatalogueId==''){
      alert(this.constants.toolNotSelected);
      this.validations_path_form.reset();
    }
  else{

    console.log(this.toolDescriptionModel);

    //
    if (this.toolDescriptionModel.toolCatalogueId == '1') {
     if(confirm(this.constants.confirmMessageForXmlToCsvToSql)){

      //Calling the service and subscribe the data
      this.migratorService.XmlToCsvToSql(this.toolDescriptionModel).subscribe(res => {

        console.log(res)

        //response from server that user can also get in the ui screen

        this.snackBar.open(res.message, "OK", {
          panelClass: 'snack'
        }

        );
        this.validations_path_form.reset();
        this.gridData();

      });
    }

    }
    else if (this.toolDescriptionModel.toolCatalogueId == '2') {
      if(confirm(this.constants.confirmMessageFoXmlModifier)){

      this.migratorService.XmlModifier(this.toolDescriptionModel).subscribe(res => {

        console.log(res)

        //response from server that user can also get in the ui screen

        this.snackBar.open(res.message, "OK", {
          panelClass: 'snack'
        }
        );
        this.validations_path_form.reset();
        this.gridData();
      });
    }
   }
    else if (this.toolDescriptionModel.toolCatalogueId == '3') {
      if(confirm(this.constants.confirmMessageForXmlSplitter)){
      this.migratorService.xmlSplitter(this.toolDescriptionModel).subscribe(res => {

        console.log(res)
        // response from server that user can also get in the ui screen

        this.snackBar.open(res.message, "OK", {
          panelClass: 'snack'
        }
        );
        this.validations_path_form.reset();
        this.gridData();
      });
    }

   }

    else if (this.toolDescriptionModel.toolCatalogueId == '4' || this.toolDescriptionModel.toolCatalogueId == '5' || this.toolDescriptionModel.toolCatalogueId == '6' || this.toolDescriptionModel.toolCatalogueId == '7' || this.toolDescriptionModel.toolCatalogueId == '8') {
      alert(this.constants.noOperationForTools)


    }
  }

}
gridData(){
  console.log(this.toolDescriptionBinding.toolCatalogueId)
  this.migratorService.getToolLog(this.toolDescriptionBinding.toolCatalogueId).subscribe(res => {
    console.log(res);
    this.logData = res;
    this.onGridReadyForLog(this.logGrid)
  });
 }

 // grid for R3 extractor starts here
 onGridReadyForR3Extractor(params){
    this.R3API = params;
    this.R3Data = [];
    this.R3API.api.setGridOption('rowData', [])
    this.spinner.start();
    console.log(this.localStorageSettings.getSettings("dnsName"));
    this.migratorService.retrieveR3Extractor(this.localStorageSettings.getSettings("dnsName")).subscribe(
      res => {
        console.log(res);
        this.R3Data = res;
        console.log(this.R3Data);
        if(this.R3Data.length === 0){
          this.R3API.api.setGridOption('rowData', []);
          this.spinner.stop();
        }
        else{
          this.R3API.api.setGridOption('rowData', this.R3Data);
          this.spinner.stop();
        }
      });
      this.spinner.stop();
 }
 // grid for R3 extractor ends here

onGridReadyStateChange(params, id) {
  this.stateChange.length = 0;
  this.stateChange = params;
  this.getdata = [];

  this.migratorService.retrieveStateChange(this.localStorageSettings.getSettings("dnsName")).subscribe(response => {
    console.log(response);
    this.statedatatemp = [];

    // Checking if response.error is true or not
    if (response.error) {
      this.snackBar.open(response.statusMessage, "OK", {
        duration: 5000,
      });
      this.getdata = null;
      this.stateChange.api.setGridOption('rowData', this.getdata);
    } else {
      console.log(response);
      this.getdata = response;
      if (this.getdata.length === 0) {
        this.stateChange.api.setGridOption('rowData', []);
      } else {
        console.log(id);
        this.getdata.forEach(eachdata => {
          console.log(eachdata.toolid);
          if (eachdata.toolid === id) {
            this.statedatatemp.push(eachdata);
          }
        });
        this.stateChange.api.setGridOption('rowData', this.statedatatemp);
      }
    }
  });
}
onGridReadyProductTypeChange(params, id) {
  this.stateChange.length = 0;
  this.stateChange = params;
  this.statedatatemp = [];
  this.getdata = [];

  this.migratorService.retrieveStateChange(this.localStorageSettings.getSettings("dnsName")).subscribe(response => {
    console.log(response);
    this.producttypedatatemp = [];

    // Checking if response.error is true or not
    if (response.error) {
      this.snackBar.open(response.statusMessage, "OK", {
        duration: 5000,
      });
      this.getdata = null;
      this.stateChange.api.setGridOption('rowData', this.getdata);
    } else {
      console.log(response);
      this.getdata = response;
      console.log(this.getdata);
      if (this.getdata.length === 0) {
        this.stateChange.api.setGridOption('rowData', []);
      } else {
        console.log(id);
        this.getdata.forEach(eachdata => {
          console.log(eachdata.toolid);
          if (eachdata.toolid === id) {
            this.producttypedatatemp.push(eachdata);
          }
        });
        this.stateChange.api.setGridOption('rowData', this.producttypedatatemp);
      }
    }
  });
}


uploadExcelFile(event: any, fileType: 'source' | 'template') {
  const file = event.target.files[0];
  if (!file) {
    this.snackBar.open(
      this.constants.noExcelFileSelected,
      "OK",
      { duration: 4000 }
    );
    return;
  }
  const validTypes = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "text/csv"
  ];
  if (!validTypes.includes(file.type)) {
    this.snackBar.open(
      "Upload only CSV/Excel file",
      "OK",
      { duration: 4000 }
    );
    return;
  }
  if (fileType === 'source') {

    this.selectedFile = file;
    this.FormValidCaseAudit.controls.sourceFileName.setValue(file.name);
    this.FormValidCaseAudit.controls.sourceFileUpload.setValue(file);

  } else {
    this.selectedTemplateFile = file;
    this.FormValidCaseAudit.controls.templateFileName.setValue(file.name);
    this.FormValidCaseAudit.controls.templateFileUpload.setValue(file);

  }

}



 /* Modified by Renuka on 10-04-2026 
    Added file upload method in Data Extractor Tool */ 
uploadCaseAuditFile() {
  this.FormValidCaseAudit.markAllAsTouched();

  const currentStatus = (this.dashboardCounts.currentStatus || '').trim().toUpperCase();
  if (
    currentStatus &&
    currentStatus !== 'COMPLETED'
) {
    this.snackBar.open(
        'Another Data Extraction run is already in progress. Please wait until it completes.',
        'OK',
        { duration: 5000 }
    );
    return;
}

  if (this.FormValidCaseAudit.invalid) {
    return;
  }
  const splitCount = Number(this.FormValidCaseAudit.controls.splitCount.value);
const maxRetry = Number(this.FormValidCaseAudit.controls.maxRetry.value);
const userName = this.FormValidCaseAudit.controls.userName.value?.trim() || '';
  const failedUserName = this.FormValidCaseAudit.controls.failedUserName.value?.trim() || '';
  const formData = new FormData();

// Split Count validation
if (!splitCount || splitCount < 1 || splitCount > 1000) {
  this.snackBar.open(
    "Split Count should be between 1 and 1000.",
    "Close",
    { duration: 3000 }
  );
  return;
}
// Max Retry validation
if (!maxRetry || maxRetry < 1 || maxRetry > 5) {
  this.snackBar.open(
    "Max Retry Count should be between 1 and 5.",
    "Close",
    { duration: 3000 }
  );
  return;
}
if (!this.selectedFile) {
    this.snackBar.open(
      "Please select Source CSV File",
      "OK",
      { duration: 4000 }
    );
    return;
  }
  if (!this.selectedTemplateFile) {
    this.snackBar.open(
      "Please select Template File",
      "OK",
      { duration: 4000 }
    );
    return;
  }
  // Source CSV
  formData.append("sourceFile", this.selectedFile);

  // Template
  formData.append("templateFile", this.selectedTemplateFile);
  formData.append("toolId", this.toolCatalogueId.toString());
  formData.append("splitCount", splitCount.toString());
  formData.append("newRunUsername", userName);
formData.append("failedRunUsername", failedUserName);
formData.append("retryCount", maxRetry.toString());
formData.append(
    "validationRequired",
    String(this.FormValidCaseAudit.value.validationRequired)
);
formData.append(
    "createdBy",
    this.localStorageSettings.getSettings("AuthUsername") ?? ''
  );
  this.spinner.start();
   this.migratorService
    .uploadCaseAuditExtraction(formData)
    .subscribe({

      next: (res: any) => {
        this.spinner.stop();

        if (res?.error === true) {
          this.snackBar.open(
            res.statusMessage || "Request failed",
            "OK",
            { duration: 5000 }
          );
          return;
        }
         this.refreshCaseAudit();
         this.snackBar.open(
          "Record Inserted Successfully",
          "OK",
          { duration: 3000 }
        );
this.selectedFile = null;
        this.selectedTemplateFile = null;
        this.FormValidCaseAudit.reset();
      },
       error: (err) => {
        this.spinner.stop();
        const message =
          err?.error?.statusMessage ||
          "Request failed";
          this.snackBar.open(
          message,
          "OK",
          { duration: 5000 }
        );
         }
    });

}

   /* Modified by Renuka on 10-04-2026 
    Added refresh method in Data Extractor Tool */ 
  refreshCaseAudit() {

    this.spinner.start();

    this.migratorService
      .getCaseAuditRefresh()
      .subscribe(res => {

        this.logData = res;

        // refresh ag-grid
        if (this.logGrid?.api) {
          this.logGrid.api.setGridOption('rowData', this.logData);
        }

        this.spinner.stop();

      });

  }

  // Download summary repot.
Download() {

  this.spinner.start();

  this.migratorService.getCurrentSourceCsvPath().subscribe({

    next: (response: any) => {

      const s3Path = response.sourceCsvPath;

      if (!s3Path) {
        this.spinner.stop();

        this.snackBar.open(
          'Source CSV file not found.',
          'OK',
          { duration: 4000 }
        );
        return;
      }

      console.log("Source CSV Path:", s3Path);
      
      this.commonService
        .downloadCsvFileFromS3({ s3Path: s3Path })
        .subscribe(

          (blob: Blob) => {

            this.spinner.stop();

            let fileName = s3Path.split('/').pop() || 'Source.csv';

            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = fileName;
            link.click();

            setTimeout(() => {
              window.URL.revokeObjectURL(url);
              link.remove();
            }, 100);

          },

          (err) => {

            this.spinner.stop();

            this.snackBar.open(
              err?.error?.statusMessage || 'Unable to download file',
              'OK',
              { duration: 5000 }
            );

          }

        );

    },

    error: () => {

      this.spinner.stop();

      this.snackBar.open(
        'Unable to retrieve source CSV path.',
        'OK',
        { duration: 5000 }
      );

    }

  });

}



 /* Modified by Renuka on 22-04-2026 
    Added file upload method in Oracle To FTP Tool */ 
uploadOracleFile(event: any) {
  const file = event.target.files[0];

  if (!file) {
    this.snackBar.open("Please select a file", "OK", { duration: 4000 });
    return;
  }

  const validTypes = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  ];

  if (!validTypes.includes(file.type)) {
    this.snackBar.open("Upload only Excel file", "OK", { duration: 4000 });
    return;
  }
  this.selectedOracleFile = file;

  this.FormValidOracle.controls.imageName.setValue(file.name);
  this.FormValidOracle.controls.imageupload.setValue(file.name);

  this.statevaluechange.fileName = file.name;
}


uploadOracleData() {

  this.FormValidOracle.markAllAsTouched();

  if (this.FormValidOracle.invalid) {
    return;
  }

  if (!this.selectedOracleFile) {
    this.snackBar.open("Please select an Excel file", "OK", { duration: 4000 });
    return;
  }

  const rawSetId = this.FormValidOracle.get('setId').value?.trim();
  const setIds = this.parseSetIds(rawSetId);

  if (setIds.length === 0 || setIds.some(id => isNaN(id))) {
    this.snackBar.open("Invalid Set Id format", "OK", { duration: 4000 });
    return;
  }

  this.spinner.start();
  
  import('rxjs').then(({ concat, from, of }) => {
    import('rxjs/operators').then(({ concatMap, toArray, catchError }) => {

      from(setIds).pipe(
        concatMap(id => {
          const formData = new FormData();
          formData.append("file", this.selectedOracleFile, "OracleToExcelConfig.xlsx");
          formData.append("setId", id.toString());
          formData.append("user", this.localStorageSettings.getSettings("AuthUsername") ?? '');

          return this.migratorService.uploadOracleExcel(formData).pipe(
            catchError(err => of({ error: true, statusMessage: err?.error?.statusMessage || "Upload failed" }))
          );
        }),
        toArray()
      ).subscribe({
        next: (results: any[]) => {
          this.spinner.stop();
          const failed = results.filter(r => r?.error === true);
          if (failed.length > 0) {
            this.snackBar.open(
              `${failed.length} record(s) failed: ${failed[0].statusMessage || 'Upload failed'}`,
              "OK", { duration: 5000 }
            );
          } else {
            this.snackBar.open(
              `${setIds.length} record(s) inserted successfully`,
              "OK", { duration: 3000 }
            );
          }
          this.selectedOracleFile = null;
          this.FormValidOracle.reset();
          this.statevaluechange.fileName = '';
          this.refreshOracle();
        },
        error: (err) => {
          this.spinner.stop();
          this.snackBar.open(
            err?.error?.statusMessage || "Upload failed",
            "OK", { duration: 5000 }
          );
        }
      });

    });
  });
}



parseSetIds(value: string): number[] {
  if (value.includes('-')) {
    const [start, end] = value.split('-').map(Number);
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  }
  return value.split(',').map(v => Number(v.trim()));
}

   /* Modified by Renuka on 22-04-2026 
    Added refresh method in Oracle To FTP Tool */ 
refreshOracle() {

  this.spinner.start();

  this.migratorService.refreshOracle().subscribe(res => {

    this.logData = res;   
    this.onGridReadyForLog(this.logGrid);

    this.spinner.stop();

  }, err => {
    this.spinner.stop();
  });

}

}